import { h } from 'preact';

function SendButton (props) {
  return (
    <svg
      viewBox="0 0 24 24"
      height={props.height || 24}
      width={props.width || 24}
      fill={props.fill || '#627895'}
      {...props}
    >
      <path d="M2 3v7.5L17 12 2 13.5V21l20-9L2 3z" />
    </svg>
  );
}

export default SendButton;
